import React, { useMemo, useCallback } from 'react';
import { StyleSheet, Pressable } from 'react-native';
import Text from '@/components/Typography/Text';
import { useModalStore } from '@/store';
import ChatInputBanner from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

const styles = StyleSheet.create({
  link: {
     marginLeft: 4,
     display: 'inline',
     textDecorationLine: 'underline'
  },
});

function ChatInputCreditsBanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();

  const handleGetCredits = useCallback(() => {
    openModal('CreditsPurchaseModal', { initialTab: 'buy-credits' });
  }, [openModal]);

  return (
    <ChatInputBanner color="danger" level={level} isCloseable={isCloseable} isDetached={isDetached}>
      {t('chatInput.credits.insufficientCredits')}
      <Pressable onPress={handleGetCredits}>
        <Text size='s' weight='medium' color='primary' style={styles.link}>
          {t('chatInput.credits.getMoreCredits')}
        </Text>
      </Pressable>
    </ChatInputBanner>
  );
}

export default React.memo(ChatInputCreditsBanner);